import { Component, Input, OnInit } from '@angular/core';
import { HelperService } from '../../main/services/helper.service';

@Component({
  selector: 'anms-detail-row-with-indicator',
  templateUrl: './detailRowWithIndicator.component.html',
  styleUrls: ['./detailRowWithIndicator.component.scss'],
  standalone: false
})
export class DetailRowWithIndicatorComponent implements OnInit {
  @Input() subLabel!: string;
  @Input() color!: string;
  @Input() label!: string;
  @Input() date!: string;
  constructor(public helperService: HelperService) { }

  ngOnInit(): void {
  }

}
